import { Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PageShopService } from '../../services/page-shop.service';
import { Subject } from 'rxjs';
import { Filter } from '../../../../interfaces/filter';
import { map, takeUntil } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { filterHandlers } from '../../filters/filter-handlers';
import { ApiService } from '../../../../service/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-widget-filters',
    templateUrl: './widget-filters.component.html',
    styleUrls: ['./widget-filters.component.scss'],
})
export class WidgetFiltersComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject<void>();

    filters: Filter[] = [];

    form: FormGroup;

    @Input() offcanvasSidebar: 'always' | 'mobile';

    @HostBinding('class.widget') classWidget = true;

    @HostBinding('class.widget-filters') classWidgetFilters = true;

    @HostBinding('class.widget-filters--offcanvas--always') get classWidgetFiltersOffcanvasAlways(): boolean {
        return this.offcanvasSidebar === 'always';
    }

    @HostBinding('class.widget-filters--offcanvas--mobile') get classWidgetFiltersOffcanvasMobile(): boolean {
        return this.offcanvasSidebar === 'mobile';
    }
    category:any;
    name:any = {
        "category" : "category",
        "sub_category" : "sub_category",
        "state" : "state",
        "city" : "city",
        "affiliation" : "affiliation",




    }
    filterForm:FormGroup;
    constructor(
        private page: PageShopService,
        private fb: FormBuilder,
        private service : ApiService,
        private route: ActivatedRoute,
        private router : Router


    ) { }

    state:any;
    originalState:any;
    city:any;
    originalCity:any;
    affiliation:any;
    originalAffiliation:any;

    ngOnInit(): void {
        this.getCategory();
        this.getSubCategory();
        this.getState();
        this.getCity();
        this.getAffiliation();
        this.filterForm = this.fb.group({
            category_id : [''],
            subcategory_id : [''],
            affiliation_id : [''],

            state_id : [''],
            city_id : [''],

        })

        this.page.list$.pipe(
            map(x => x.filters),
            takeUntil(this.destroy$),
        ).subscribe(filters => {
            this.filters = filters;

            const filtersWithHandlers = this.page.filters
                .map(filter => ({filter, handler: filterHandlers.find(x => x.type === filter.type)}))
                .filter(x => x.handler);

            const fields: {[filterSlug: string]: FormControl} = {};

            filtersWithHandlers.forEach(({filter, handler}) => {
                fields[filter.slug] = this.fb.control(filter.value);
                fields[filter.slug].valueChanges.subscribe(value => {
                    this.page.setFilterValue(filter.slug, handler.serialize(value));
                });
            });

            this.form = this.fb.group(fields);
        });
    }
    originalCategory:any;
    search(field, data){
        let val = data.target.value
        console.log(field, val)
        if(field === 'category'){
            if (val && val.trim() != '') {
                this.category = this.originalCategory;

                this.category = this.category.filter((item) => {
                  return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
              }
              else {
                this.category = this.originalCategory;
              }
        }
        if(field === 'state'){
            if (val && val.trim() != '') {
                this.state = this.originalState;

                this.state = this.state.filter((item) => {
                  return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
              }
              else {
                this.state = this.originalState;
              }
        }
        if(field === 'city'){
            if (val && val.trim() != '') {
                this.city = this.originalCity;

                this.city = this.city.filter((item) => {
                  return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
              }
              else {
                this.city = this.originalCity;
              }
        }
        if(field === 'sub_category'){
            if (val && val.trim() != '') {
                this.subCategory = this.originalSubCategory;

                this.subCategory = this.subCategory.filter((item) => {
                  return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
              }
              else {
                this.subCategory = this.originalSubCategory;
              }
        }
        if(field === 'affiliation'){
            if (val && val.trim() != '') {
                this.affiliation = this.originalAffiliation;

                this.affiliation = this.affiliation.filter((item) => {
                  return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
              }
              else {
                this.affiliation = this.originalAffiliation;
              }
        }
    }
    ngAfterViewChecked(){
        this.route.queryParams.subscribe((p:any) =>
            this.getFilter(p)
        );

    }
    resetFilter(){
        const urlTree = this.router.createUrlTree([], {
            queryParams: { reset: true },
            queryParamsHandling: "merge",
            preserveFragment: true });

        this.router.navigateByUrl(urlTree);
    }
    getCategory(){
        this.service.getRegistrationType().subscribe((res:any ) => {
            this.category =res;
            let data = {
                "id" : "0",
                "name" : "All"
            }
            this.category.unshift(data);
            this.originalCategory=this.category;

        })
    }
    subCategory:any;
    originalSubCategory :any;

    getSubCategory(){
        this.service.getSubRegistrationType().subscribe((res:any ) => {
            this.subCategory =res;
            this.originalSubCategory = res;
            let data = {
                "id" : "0",
                "name" : "All"
            }
            this.subCategory.unshift(data);
        })
    }
    getFilter(parma){

        if(parma != undefined){
            if(parma.category_id){
                if(parma.category_id === "0"){
                    this.subCategory = this.originalSubCategory
                    return false
                }if(!this.originalSubCategory){return false}
                let data = this.originalSubCategory
                this.filterForm.controls.category_id.setValue(parma.category_id)
                this.subCategory = data.filter(val =>
                    val.registrations_type === Number(parma.category_id)
                    )
                    let newData = {
                        "id" : "0",
                        "name" : "All"
                    }
                    this.subCategory.unshift(newData);
            }
            if(parma.state_id){
                if(parma.state_id === "0"){
                    this.city = this.originalCity
                    return false
                }
                if(!this.originalCity){return false}
                console.log("state is change ", parma.state_id)
                let data = this.originalCity
                this.filterForm.controls.state_id.setValue(parma.state_id)
                this.city = data.filter(val =>
                    val.state === Number(parma.state_id)
                    )
                console.log(this.city)
                let newData = {
                    "id" : "0",
                    "name" : "All"
                }
                this.city.unshift(newData);
            }

        }

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    trackBySlug(index: number, filter: Filter): string {
        return filter.slug;
    }

    getState(){
        this.service.getState().subscribe((res:any) => {
            this.state = res;
            let data = {
                "id" : "0",
                "name" : "All"
            }
            this.state.unshift(data);
            this.originalState = this.state;
        })
    }
    getCity(){
        this.service.getCity().subscribe((res:any) => {
            this.city = res;
            let data = {
                "id" : "0",
                "name" : "All"
            }
            this.city.unshift(data);
            this.originalCity = this.city;
        })
    }
    getAffiliation(){
        this.service.getAffiliation().subscribe((res:any) => {
            this.affiliation = res;
            let data = {
                "id" : "0",
                "name" : "All"
            }
            this.affiliation.unshift(data);
            this.originalAffiliation = this.affiliation;
        })
    }
}
